namespace Nobox.Nobox.Pages {
    export interface FormUploadMultiFileRequest {
        TnId?: number;
        Data?: Web.Hubs.MessageMedia[];
    }
}
